export default __webpack_public_path__ + "static/media/promos-banner.5a437813.webp";